document.addEventListener("DOMContentLoaded", function () {
    let loadMoreBtn = document.getElementById("load-more");
    let productList = document.getElementById("product-list");
    let nextPageLink = document.getElementById("next-page");

    if (!loadMoreBtn) {
        return;
    }
    
    if (!nextPageLink) {
        loadMoreBtn.style.display = "none"; // Hide if no next page
        return;
    }

    loadMoreBtn.addEventListener("click", function () {
        if (!nextPageLink) return;

        let nextPageUrl = nextPageLink.getAttribute("href");

        if (!nextPageUrl) {
            loadMoreBtn.style.display = "none";
            return;
        }

        loadMoreBtn.textContent = "Loading...";

        fetch(nextPageUrl)
            .then(response => response.text())
            .then(html => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, "text/html");

                let newItems = doc.getElementById("product-grid").innerHTML;
                let newNextPage = doc.getElementById("next-page");

                productList.insertAdjacentHTML("beforeend", newItems);

                if (newNextPage) {
                    nextPageLink.setAttribute("href", newNextPage.getAttribute("href"));
                } else {
                    loadMoreBtn.style.display = "none"; // Hide if no more pages
                }

                loadMoreBtn.textContent = "Load More";
            })
            .catch(error => {
                console.error("Error loading more products:", error);
                loadMoreBtn.textContent = "Load More";
            });
    });
});
